<template>
  <div id="bottom-immobilization" class="relative">
    <img
      class="home-bg footer-bg"
      :class="{ 'footer-bg2': voiceFooterData == 'en-US' }"
      v-lazy="require('../../assets/images/index/bottom.png')"
      alt=""
    />
    <div class="home-bg abs">
      <div class="container" style="margin:0 auto;height:100%">
        <div class="footer-content flex">
          <div class="footer-content-left">
            <div class="footer-logo-box flex">
              <img
                class="footer-logo"
                src="../../assets/images/index/footer-logo.png"
                alt=""
              />
              <div class="phone-stock-box stock">
                <div>
                  300532 <span>{{ $t("localization.footerFont1") }}</span>
                </div>
              </div>
            </div>
            <div class="phone-stock flex">
              <div class="phone-stock-box">
                <div v-if="voiceFooterData == 'zh-CN'">0755-25161222</div>
                <div v-else>0755-89902262</div>
                <div class="duty-time">{{ $t("localization.footerFont") }}</div>
              </div>
              <div class="phone-stock-box stock">
                <div>marketing@nti56.com</div>
                <div class="duty-time ">
                  {{ $t("localization.footerFont14") }}
                </div>
              </div>
            </div>
            <div class="friendship-link flex">
              <span>{{ $t("localization.footerFont3") }}</span>
              <div class="flex" style="flex-wrap:wrap">
                <a
                  class="friendship-a"
                  :href="item.blogrollLink"
                  target="_blank"
                  v-for="item in linkData"
                  :key="item.blogrollName"
                  >{{ item.blogrollName }}</a
                >
              </div>
            </div>
            <div
              class="friendship-a"
              v-if="voiceFooterData == 'en-US'"
              style="color:rgba(255, 255, 255, 0.8);margin-top:6px"
            >
              Address：No. 26 Cuibao Road, Baolong Street, Longgang District,
              Shenzhen, China.
            </div>
          </div>
          <div class="footer-content-right flex">
            <div class="code-img-box">
              <img
                class="code-img"
                v-lazy="require('../../assets/images/index/dd.png')"
                alt=""
              />
              <div class="friendship-link flex-center" style="margin-top:14px">
                {{ $t("localization.footerFont9") }}
              </div>
            </div>
            <div class="code-img-box">
              <img
                class="code-img"
                v-lazy="require('../../assets/images/index/wx.png')"
                alt=""
              />
              <div class="friendship-link flex-center" style="margin-top:14px">
                {{ $t("localization.footerFont10") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="copyright">
        {{ $t("localization.footerFont11") }}
        <a
          style="color: rgba(255, 255, 255, 0.4)"
          href="https://beian.miit.gov.cn"
          target="_blank"
          >{{ $t("localization.footerFont12") }}</a
        >
        {{ $t("localization.footerFont13") }}{{ year }} {{ $t("localization.footerFont15") }}
      </p>
    </div>
  </div>
</template>
<script>
import { getFriendshipLink } from "@/api/index.js";
export default {
  data() {
    return {
      voiceFooterData: "",
      voice: "",
      linkData: [],
      year:''
    };
  },
  mounted() {
    const date = new Date()
this.year = date.getFullYear()
    this.voiceFooterData =
      localStorage.getItem("DefaultLanguage") == null
        ? "zh-CN"
        : localStorage.getItem("DefaultLanguage");

    this.voice =
      localStorage.getItem("DefaultLanguage") == "en-US" ? "en" : "zh";
    this.getFriendshipLinkData({ language: this.voice });
    window.addEventListener("setItem", e => {
      if (e.key == "DefaultLanguage") {
        if (e.newValue == "en-US") {
          this.voiceFooterData = "en-US";
          this.voice = "en";
        } else {
          this.voiceFooterData = "zh-CN";
          this.voice = "zh";
        }
        this.getFriendshipLinkData({ language: this.voice });
      }
    });
  },
  methods: {
    getFriendshipLinkData(data) {
      getFriendshipLink(data).then(res => {
        this.linkData = res.data;
      });
    }
  }
};
</script>
<style>
.friendship-a:hover {
  color: #d73d3d;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer-box.vue